// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"18383faf529fecdcdfd0","682":"65ebcaefbbae60c5098a","883":"0d7c961380f6fd28f1c0"}[chunkId] + ".js";
};